import * as React from "react";
import { forwardRef } from "react";
const SvgSwitchOn = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 28, height: 16, viewBox: "0 0 28 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { x: 0.5, y: 0.5, width: 27, height: 15, rx: 7.5, fill: "#F7F7F7", stroke: "#DEDEDE" }), /* @__PURE__ */ React.createElement("circle", { cx: 20, cy: 8, r: 6, fill: "#0ACF83" }));
const ForwardRef = forwardRef(SvgSwitchOn);
export { ForwardRef as ReactComponent };
